import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";

import { NotificationType } from "../../apis/networkdashboard/graphql/graphql";
import { HealthRecord } from "../../apis/stats/rest/models";
import { LoaderComponent } from "../../components/common/loader/loader";
import { NetworkServiceElement } from "../../components/subscriptions-list/network-service-element/network-service-element";
import { ServiceElementViewData } from "../../components/subscriptions-list/network-service-element/network-service-element.model";
import { LoadingState } from "../../services/loading-state";

export type AugmentedSubscription = {
  subscription: ServiceElementViewData;
  disruption: NotificationType | undefined;
  health: HealthRecord;
};

@Component({
  selector: "subscriptions-results",
  templateUrl: "subscriptions-results.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoaderComponent, NetworkServiceElement],
})
export class SubscriptionsResultsComponent {
  protected loadingState = inject(LoadingState);

  filteredSubscriptionsAugmented = input.required<AugmentedSubscription[]>();
}
